import Event from '../../core/Event';

export default class OrderProductsSearchRequested extends Event {
    public static type = 'OrderProductsSearchRequested';

    constructor(public readonly query: string) {
        super(OrderProductsSearchRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderProductsSearchRequested.ts